import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface CashbackInfoResponseDto {
  enabled: boolean;
  /** Campanha vigente gera cashback (ACTIVE). PAUSED só resgata → esconde "vai ganhar". */
  canEarn?: boolean;
  reason?: 'cashback_not_enabled' | 'store_not_active' | 'pdv_channel_not_active';
  /** Saldo disponível em centavos */
  balance?: number;
  /** Cashback a ganhar nesta compra, em centavos */
  cashbackToEarn?: number;
  percentage?: number;
  minimumOrderValue?: number;
  /** Mínimo do pedido para resgatar, em centavos. 0 = sem mínimo. */
  minimumRedeemOrderValue?: number;
  customer?: { name: string; phone: string } | null;
}

export interface CashbackApplyRequestDto {
  idi: number;
  cartId: number;
  cashbackValue: number;
  clientId: number;
  /** Total da mesa em centavos; gateia o mínimo de resgate no fiber. */
  cartTotal?: number;
}

@Injectable({
  providedIn: 'root',
})
export class CashbackApiService {
  constructor(private http: HttpClient) {}

  getCashbackInfo(
    idi: number,
    clientId: number,
    cartTotal: number,
  ): Observable<CashbackInfoResponseDto> {
    return this.http.get<CashbackInfoResponseDto>('cashback/info', {
      params: { idi, clientId, cartTotal },
    });
  }

  /**
   * Aplica intent de cashback na mesa (persiste user_table_cashback no back
   * SEM debitar a wallet). O debit real só ocorre no webhook PAID via
   * /cashback/redeem chamado pelo nest.
   */
  applyCashback(dto: CashbackApplyRequestDto): Observable<any> {
    return this.http.post<any>('cashback/apply', dto);
  }

  /** Remove o intent de cashback da mesa (soft-delete, sem fiber). */
  removeAppliedCashback(idi: number, cartId: number): Observable<any> {
    return this.http.delete<any>('cashback/apply', {
      params: { idi, cartId },
    });
  }
}
